/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CampaignOrderSource } from '../models/CampaignOrderSource'
import type { ChartPrecision } from '../models/ChartPrecision'
import type { CreationType } from '../models/CreationType'
import type { Device } from '../models/Device'
import type { DukatOrderStatus } from '../models/DukatOrderStatus'
import type { Error } from '../models/Error'
import type { ExternalStatsType } from '../models/ExternalStatsType'
import type { GenericCampaignType } from '../models/GenericCampaignType'
import type { KeyEvent } from '../models/KeyEvent'
import type { NewsletterType } from '../models/NewsletterType'
import type { PaymentType } from '../models/PaymentType'
import type { ProductType } from '../models/ProductType'
import type { PushStatType } from '../models/PushStatType'
import type { RequestArchiveAllCampaigns } from '../models/RequestArchiveAllCampaigns'
import type { RequestCampaignCopy } from '../models/RequestCampaignCopy'
import type { RequestCampaignPotentialCalculator } from '../models/RequestCampaignPotentialCalculator'
import type { RequestCreateAnyCampaign } from '../models/RequestCreateAnyCampaign'
import type { RequestCreatePushCampaign } from '../models/RequestCreatePushCampaign'
import type { RequestSendTestStaticMailing } from '../models/RequestSendTestStaticMailing'
import type { RequestTestPushCampaign } from '../models/RequestTestPushCampaign'
import type { RequestUpdateAnyCampaign } from '../models/RequestUpdateAnyCampaign'
import type { RequestUpdatePushCampaign } from '../models/RequestUpdatePushCampaign'
import type { RequestUploadMailingHeaderImage } from '../models/RequestUploadMailingHeaderImage'
import type { ResponseAvailableCampaignTypes } from '../models/ResponseAvailableCampaignTypes'
import type { ResponseCampaign } from '../models/ResponseCampaign'
import type { ResponseCampaignBalance } from '../models/ResponseCampaignBalance'
import type { ResponseCampaignHistory } from '../models/ResponseCampaignHistory'
import type { ResponseCampaignList } from '../models/ResponseCampaignList'
import type { ResponseCampaignListByFeedId } from '../models/ResponseCampaignListByFeedId'
import type { ResponseCampaignPotentialCalculator } from '../models/ResponseCampaignPotentialCalculator'
import type { ResponseCampaignRunningConditions } from '../models/ResponseCampaignRunningConditions'
import type { ResponseCampaignStats } from '../models/ResponseCampaignStats'
import type { ResponseCampaignStatsSummary } from '../models/ResponseCampaignStatsSummary'
import type { ResponseCampaignSummary } from '../models/ResponseCampaignSummary'
import type { ResponseCampaignToArchive } from '../models/ResponseCampaignToArchive'
import type { ResponseChartData } from '../models/ResponseChartData'
import type { ResponseEntityCreated } from '../models/ResponseEntityCreated'
import type { ResponseGenericCampaign } from '../models/ResponseGenericCampaign'
import type { ResponsePushChartData } from '../models/ResponsePushChartData'
import type { ResponseSalesCampaignOrderList } from '../models/ResponseSalesCampaignOrderList'
import type { ResponseSimpleCampaignListItem } from '../models/ResponseSimpleCampaignListItem'
import type { ResponseUploadMailingHeaderImage } from '../models/ResponseUploadMailingHeaderImage'
import type { StatType } from '../models/StatType'
import type { StatusFilter } from '../models/StatusFilter'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class CampaignService {
  /**
   * Tworzy nową kampanię dowolnego
   * @returns Error unexpected error
   * @returns ResponseEntityCreated kampania utworzona
   * @throws ApiError
   */
  public static createAnyCampaign({
    requestBody,
  }: {
    /**
     * Dane kampanii
     */
    requestBody: RequestCreateAnyCampaign
  }): CancelablePromise<Error | ResponseEntityCreated> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/any-campaign',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Aktualizuje kampanię dowolnego typu
   * @returns Error unexpected error
   * @returns any dane zapisane
   * @throws ApiError
   */
  public static updateAnyCampaign({
    campaignId,
    requestBody,
  }: {
    campaignId: number
    /**
     * Dane kampanii
     */
    requestBody: RequestUpdateAnyCampaign
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/any-campaign/{campaignId}',
      path: {
        campaignId: campaignId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Header upload
   * @returns ResponseUploadMailingHeaderImage Header upload
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static uploadHeaderImage({
    shopId,
    formData,
  }: {
    shopId: number
    /**
     * Obraz do wgrania
     */
    formData?: RequestUploadMailingHeaderImage
  }): CancelablePromise<ResponseUploadMailingHeaderImage | Error> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/mc-mailing-campaign/header-image/{shopId}',
      path: {
        shopId: shopId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    })
  }

  /**
   * Tworzy kampanię push
   *
   * @returns Error unexpected error
   * @returns any dane zapisane
   * @throws ApiError
   */
  public static addPushCampaign({
    requestBody,
  }: {
    /**
     * Dane kampanii
     */
    requestBody: RequestCreatePushCampaign
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/mc-push-campaign',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Modyfikuje kampanię push
   *
   * @returns Error unexpected error
   * @returns any dane zapisane
   * @throws ApiError
   */
  public static modifyPushCampaign({
    campaignId,
    requestBody,
  }: {
    campaignId: number
    /**
     * Dane kampanii
     */
    requestBody: RequestUpdatePushCampaign
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/mc-push-campaign/{campaignId}',
      path: {
        campaignId: campaignId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Wysyła test kampanii push
   *
   * @returns Error unexpected error
   * @returns any dane zapisane
   * @throws ApiError
   */
  public static testPushCampaign({
    requestBody,
  }: {
    /**
     * Dane kampanii
     */
    requestBody: RequestTestPushCampaign
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/mc-push-campaign/test',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Pobiera dane statystyczne kampanii
   * @returns ResponseChartData podsumowanie statystyk
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getTimeSeriesStats({
    metrics,
    shopId,
    dateFrom,
    campaignIds,
    creationsIds,
    dateTo,
    devices,
    precision,
  }: {
    /**
     * wybierane typy statystyk
     */
    metrics: Array<StatType>
    shopId: number
    /**
     * data od której będą statystyki kampanii
     */
    dateFrom: string
    /**
     * identyfikatory kampanii
     */
    campaignIds?: Array<number>
    /**
     * identyfikatory kreacji reklamowej
     */
    creationsIds?: Array<number>
    /**
     * data do której będą statystyki kampanii
     */
    dateTo?: string
    /**
     * filtr na urządzenie
     */
    devices?: Array<Device>
    /**
     * ziarno agregacji danych
     */
    precision?: ChartPrecision
  }): CancelablePromise<ResponseChartData | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/time-series-stats',
      query: {
        metrics: metrics,
        campaignIds: campaignIds,
        creationsIds: creationsIds,
        shopId: shopId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        devices: devices,
        precision: precision,
      },
    })
  }

  /**
   * Pobiera dane statystyczne kampanii push
   * @returns ResponsePushChartData podsumowanie statystyk
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getPushTimeSeriesStats({
    metrics,
    shopId,
    dateFrom,
    campaignIds,
    dateTo,
    precision,
  }: {
    /**
     * wybierane typy statystyk dla pushy
     */
    metrics: Array<PushStatType>
    shopId: number
    /**
     * data od której będą statystyki kampanii
     */
    dateFrom: string
    /**
     * identyfikatory kampanii
     */
    campaignIds?: Array<number>
    /**
     * data do której będą statystyki kampanii
     */
    dateTo?: string
    /**
     * ziarno agregacji danych
     */
    precision?: ChartPrecision
  }): CancelablePromise<ResponsePushChartData | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/push-time-series-stats',
      query: {
        metrics: metrics,
        campaignIds: campaignIds,
        shopId: shopId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        precision: precision,
      },
    })
  }

  /**
   * zwraca listę kampanii przypisanych do sklepu
   *
   * @returns ResponseCampaignList lista kampanii
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignListWithStats({
    shopId,
    page,
    limit,
    creationType,
    sortBy = 'createDate',
    sortDir,
    nameSearch,
    fetchArchived,
    status,
    type,
    excludeType,
    dateFrom,
    dateTo,
    relativeRange,
    fetchExternalStats,
  }: {
    shopId: number
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * typ kreacji reklamowej
     */
    creationType?: CreationType
    /**
     * pole po którym będą sortowane wyniki zapytania
     */
    sortBy?:
      | 'name'
      | 'CR'
      | 'INCOME'
      | 'CLICKS'
      | 'TRANSACTIONS'
      | 'AOV'
      | 'COST'
      | 'ROAS'
      | 'COS'
      | 'VIMP'
      | 'VIEWS'
      | 'CTR'
      | 'VCTR'
      | 'VRATE'
      | 'ECPC'
      | 'OPENRATE'
      | 'OCTR'
      | 'OPEN'
      | 'DELIVERY'
      | 'EVENTS'
      | 'createDate'
    /**
     * kierunek sortowania
     */
    sortDir?: 'asc' | 'desc'
    /**
     * filtr na nazwę kampanii
     */
    nameSearch?: string
    /**
     * czy pobierać razem z archiwalnymi
     */
    fetchArchived?: boolean
    /**
     * filtr na status kampanii
     */
    status?: StatusFilter
    /**
     * filtr na typ
     */
    type?: GenericCampaignType | ProductType | NewsletterType
    /**
     * filtr na wykluczenie typów
     */
    excludeType?: GenericCampaignType | ProductType | NewsletterType
    /**
     * data od której będą statystyki kampanii
     */
    dateFrom?: string
    /**
     * data do której będą statystyki kampanii
     */
    dateTo?: string
    /**
     * data do której będą statystyki kampanii
     */
    relativeRange?:
      | 'THIS_MONTH'
      | 'TODAY'
      | 'YESTERDAY'
      | 'THIS_WEEK'
      | 'LAST_7_DAYS'
      | 'LAST_30_DAYS'
      | 'THIS_YEAR'
    /**
     * jakie statystyki zewnętrze pobrać
     */
    fetchExternalStats?: Array<ExternalStatsType>
  }): CancelablePromise<ResponseCampaignList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign',
      query: {
        creationType: creationType,
        shopId: shopId,
        sortBy: sortBy,
        sortDir: sortDir,
        page: page,
        limit: limit,
        nameSearch: nameSearch,
        fetchArchived: fetchArchived,
        status: status,
        type: type,
        excludeType: excludeType,
        dateFrom: dateFrom,
        dateTo: dateTo,
        relativeRange: relativeRange,
        fetchExternalStats: fetchExternalStats,
      },
    })
  }

  /**
   * zwraca listę kampanii przypisanych do feeda
   *
   * @returns ResponseCampaignListByFeedId lista kampanii przypisanych do feeda
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignListByFeedId({
    feedId,
    page,
    limit,
    sortDir,
    sortBy,
  }: {
    feedId: number
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * kierunek sortowania
     */
    sortDir?: 'asc' | 'desc'
    /**
     * pole po którym będą sortowane wyniki zapytania
     */
    sortBy?: 'name' | 'status'
  }): CancelablePromise<ResponseCampaignListByFeedId | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/feed/{feedId}',
      path: {
        feedId: feedId,
      },
      query: {
        sortDir: sortDir,
        page: page,
        limit: limit,
        sortBy: sortBy,
      },
    })
  }

  /**
   * Pobiera podsumowanie statystyk kampanii
   * @returns ResponseCampaignStatsSummary lista kampanii
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignStatsSummary({
    shopId,
    dateFrom,
    campaignIds,
    dateTo,
    creationType,
    nameSearch,
    fetchArchived,
    status,
    type,
    fetchExternalStats,
  }: {
    shopId: number
    /**
     * data od której będą statystyki kampanii
     */
    dateFrom: string
    /**
     * identyfikatory kampanii
     */
    campaignIds?: Array<number>
    /**
     * data do której będą statystyki kampanii
     */
    dateTo?: string
    /**
     * typ kreacji reklamowej
     */
    creationType?: CreationType
    /**
     * filtr na nazwę kampanii
     */
    nameSearch?: string
    /**
     * czy pobierać razem z archiwalnymi
     */
    fetchArchived?: boolean
    /**
     * filtr na status kampanii
     */
    status?: StatusFilter
    /**
     * filtr na typ
     */
    type?: GenericCampaignType | ProductType
    /**
     * jakie statystyki zewnętrze pobrać
     */
    fetchExternalStats?: Array<ExternalStatsType>
  }): CancelablePromise<ResponseCampaignStatsSummary | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/stats-summary',
      query: {
        campaignIds: campaignIds,
        shopId: shopId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        creationType: creationType,
        nameSearch: nameSearch,
        fetchArchived: fetchArchived,
        status: status,
        type: type,
        fetchExternalStats: fetchExternalStats,
      },
    })
  }

  /**
   * zwraca informacje o wybranej kampanii
   *
   * @returns any infomacje o kampanii
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaign({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<(ResponseCampaign | ResponseGenericCampaign) | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * zwraca listę warunków opisujących status działąnia kampani
   *
   * @returns ResponseCampaignRunningConditions tablica warunków
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static campaignRunningConditions({
    campaignId,
    modifyType,
  }: {
    campaignId: number
    modifyType: 'CREATE' | 'UPDATE' | 'RUN'
  }): CancelablePromise<ResponseCampaignRunningConditions | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/running-conditions/{campaignId}',
      path: {
        campaignId: campaignId,
      },
      query: {
        modifyType: modifyType,
      },
    })
  }

  /**
   * wstrzymuje kampanię o wybranym ID
   *
   * @returns Error unexpected error
   * @returns any kampania zatrzymana
   * @throws ApiError
   */
  public static stopCampaign({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/campaign/{campaignId}/stop',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * ponownie uruchamia zapauzowaną kampanię o wybranym ID
   *
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static startCampaign({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/campaign/{campaignId}/start',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * Zwraca saldo dla danej kampanii (pobrane z bankiera)
   *
   * @returns ResponseCampaignBalance wartość salda
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignBalance({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<ResponseCampaignBalance | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/balance',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * Zwraca historię edycji kampanii
   *
   * @returns ResponseCampaignHistory Historia kampanii
   * @throws ApiError
   */
  public static getCampaignHistory({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<Array<ResponseCampaignHistory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/history',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * Zwraca podgląd kampanii dowolnego typu
   *
   * @returns string Podgląd kampanii
   * @throws ApiError
   */
  public static getCampaignPreview({
    campaignId,
    creationId,
    creationVariant,
    creationFormat,
  }: {
    campaignId: number
    /**
     * identyfikator kreacji reklamowej
     */
    creationId?: number
    creationVariant?: 'txt' | 'txt_gfx' | 'native_box' | 'related_content'
    /**
     * format kreacji zaisany jako SZEROKOSCxWYSOKOSC (120x600)
     */
    creationFormat?: string
  }): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/preview',
      path: {
        campaignId: campaignId,
      },
      query: {
        creationId: creationId,
        creationVariant: creationVariant,
        creationFormat: creationFormat,
      },
    })
  }

  /**
   * Zwraca linki do podglądu kampanii na serwisie
   *
   * @returns any Podgląd kampanii
   * @throws ApiError
   */
  public static getFeedCampaignPreviewUrls({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<Array<any>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/feed-preview-urls',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * Zraca podsumowanie kampanii (dane budżetowe)
   *
   * @returns any podsumowanie danych budżetowych
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignSummary({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<ResponseCampaignSummary | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/summary',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * zwraca szczegółowe statystki dla kampanii z podziałem na device, a dla kampanii display również z podziałem
   * na kreacje, a dla natywek równiez z podziałem na warianty
   *
   * @returns ResponseCampaignStats lista statystyk per device, per kreacja
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignStatsDetails({
    campaignId,
    dateFrom,
    sortBy = 'createDate',
    sortDir,
    dateTo,
  }: {
    campaignId: number
    /**
     * data od której będą statystyki
     */
    dateFrom: string
    /**
     * pole po którym będą sortowane kreacje w statystykach
     */
    sortBy?:
      | 'name'
      | 'CR'
      | 'INCOME'
      | 'CLICKS'
      | 'TRANSACTIONS'
      | 'AOV'
      | 'COST'
      | 'ROAS'
      | 'COS'
      | 'VIMP'
      | 'VIEWS'
      | 'CTR'
      | 'VCTR'
      | 'VRATE'
      | 'ECPC'
      | 'OPENRATE'
      | 'OCTR'
      | 'OPEN'
      | 'DELIVERY'
      | 'createDate'
    /**
     * kierunek sortowania
     */
    sortDir?: 'asc' | 'desc'
    /**
     * data do której będą statystyki
     */
    dateTo?: string
  }): CancelablePromise<ResponseCampaignStats | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/{campaignId}/stats-details',
      path: {
        campaignId: campaignId,
      },
      query: {
        sortBy: sortBy,
        sortDir: sortDir,
        dateFrom: dateFrom,
        dateTo: dateTo,
      },
    })
  }

  /**
   * Kopiuje kampanie
   *
   * @returns Error unexpected error
   * @returns ResponseEntityCreated kampania utworzona
   * @throws ApiError
   */
  public static copyCampaign({
    campaignId,
    requestBody,
  }: {
    campaignId: number
    /**
     * Dane kampanii
     */
    requestBody?: RequestCampaignCopy
  }): CancelablePromise<Error | ResponseEntityCreated> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/campaign/{campaignId}/copy',
      path: {
        campaignId: campaignId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Wysyła testowy mailing statyczny
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static sendTestStaticMailing({
    creationId,
    requestBody,
  }: {
    /**
     * identyfikator kreacji reklamowej
     */
    creationId: number
    /**
     * Dane mailingu statycznego
     */
    requestBody: RequestSendTestStaticMailing
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/creation/{creationId}/send-test-static-mailing',
      path: {
        creationId: creationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Archiwizuje kampanię
   *
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static archiveCampaigns({
    campaignId,
  }: {
    campaignId: number
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/campaign/{campaignId}/archive',
      path: {
        campaignId: campaignId,
      },
    })
  }

  /**
   * Archiwizuje wszystkie kampanię, które zakończyły się X dni temu
   *
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static archiveAllCampaigns({
    shopId,
    requestBody,
  }: {
    shopId: number
    /**
     * Dane kampanii
     */
    requestBody?: RequestArchiveAllCampaigns
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/campaign/{shopId}/archive-all',
      path: {
        shopId: shopId,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * zwraca listę zdarzeń kluczowych (pod CPA)
   *
   * @returns KeyEvent lista zdarzeń kluczowych
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getKeyEvents({
    shopId,
  }: {
    shopId: number
  }): CancelablePromise<Array<KeyEvent> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/key-events/{shopId}',
      path: {
        shopId: shopId,
      },
    })
  }

  /**
   * zwraca dostępne typy kampani dla sklepu
   *
   * @returns ResponseAvailableCampaignTypes dostępne typy kampani dla sklepu
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getAvailableCampaignTypes({
    shopId,
  }: {
    shopId: number
  }): CancelablePromise<ResponseAvailableCampaignTypes | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign-types/{shopId}',
      path: {
        shopId: shopId,
      },
    })
  }

  /**
   * zwraca uproszczoną listę kampanii przypisanych do sklepu
   *
   * @returns ResponseSimpleCampaignListItem lista kampanii
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getSimpleCampaignList({
    shopId,
    onlyArchive,
    type,
  }: {
    shopId: number
    onlyArchive?: boolean
    /**
     * filtr na typ
     */
    type?: GenericCampaignType | ProductType | NewsletterType
  }): CancelablePromise<Array<ResponseSimpleCampaignListItem> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/simple-campaign-list/{shopId}',
      path: {
        shopId: shopId,
      },
      query: {
        onlyArchive: onlyArchive,
        type: type,
      },
    })
  }

  /**
   * zwraca listę kampanii, które zostaną wkrótce zarchiwizowane
   *
   * @returns ResponseCampaignToArchive lista kampanii
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getCampaignsToArchive({
    shopId,
    days,
  }: {
    shopId: number
    days: number
  }): CancelablePromise<Array<ResponseCampaignToArchive> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaigns-to-archive/{shopId}',
      path: {
        shopId: shopId,
      },
      query: {
        days: days,
      },
    })
  }

  /**
   * @returns ResponseCampaignPotentialCalculator kalkulator zasięgów
   * @throws ApiError
   */
  public static getCampaignPotential({
    requestBody,
  }: {
    /**
     * targetowanie
     */
    requestBody: RequestCampaignPotentialCalculator
  }): CancelablePromise<Array<ResponseCampaignPotentialCalculator>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/campaign/potential-calculator',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * zwraca połączoną listę kampanii ads i zleceń z Dukata
   *
   * @returns ResponseSalesCampaignOrderList połączona lista kampanii i zleceń
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getSalesCampaignOrderList({
    adminsIds,
    clientIds,
    page,
    limit,
    source,
    dateFrom,
    dateTo,
    type,
    status,
    accountType,
    paymentType,
    shopId,
    shopCategoryId,
    advOrderOwnerId,
    nameSearch,
  }: {
    adminsIds: Array<number>
    clientIds: Array<number>
    /**
     * numer strony do pobrania
     */
    page: number
    /**
     * liczba elementów do pobrania
     */
    limit: number
    /**
     * typ zlecenia
     */
    source?: CampaignOrderSource
    /**
     * data od której będą zwrócone zlecenia
     */
    dateFrom?: string
    /**
     * data do której będą zwrócone zlecenia
     */
    dateTo?: string
    /**
     * filtr na typ kampanii WPADS
     */
    type?: GenericCampaignType | NewsletterType | ProductType
    /**
     * filtr na status zlecenia
     */
    status?: StatusFilter | DukatOrderStatus
    /**
     * typ konta
     */
    accountType?: 'AGENCY' | 'PUBLISHER'
    /**
     * typ rozliczenia
     */
    paymentType?: PaymentType
    /**
     * id witryny
     */
    shopId?: number
    /**
     * id branży sklepu
     */
    shopCategoryId?: number
    /**
     * właściciel zlecenia reklamowego
     */
    advOrderOwnerId?: number
    /**
     * filtr na nazwę kampanii lub zlecenia
     */
    nameSearch?: string
  }): CancelablePromise<ResponseSalesCampaignOrderList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/campaign/sales-list',
      query: {
        source: source,
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: type,
        status: status,
        accountType: accountType,
        paymentType: paymentType,
        shopId: shopId,
        shopCategoryId: shopCategoryId,
        advOrderOwnerId: advOrderOwnerId,
        adminsIds: adminsIds,
        nameSearch: nameSearch,
        clientIds: clientIds,
        page: page,
        limit: limit,
      },
    })
  }
}
